import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd'
import ResultFilter from './ResultFilter'
import SearchFlightsUpdate from './SearchFlightsUpdate';
import RoundTripFilter from './RoundTripFilter';
import ResultFlightsTypeVender from './ResultFlightsTypeVender';
import { useSelector } from 'react-redux';
import { FaArrowUp, FaChevronUp } from 'react-icons/fa';
import { capitalizeWords } from '../../../utils/Constants';
import FlightLoader from '../../../layout/FlightLoader';
import DateChangePreviewNext from './DateChangePreviewNext';
import { useLocation } from 'react-router-dom';
import FlightResultContent from './FlightResultContent';
import RewardPointsToast from './RewardPointsToast';
import Seo from '../../helmet/Helmet';

const Result = () => {
    const [returnFlightFilter, setReturnFlight] = useState('');

    useEffect(() => {
        const intervalId = setInterval(() => {
            const returnFlight = JSON.parse(sessionStorage.getItem('returnFlight'));
            setReturnFlight(returnFlight);
        }, 10);
        return () => clearInterval(intervalId);
    }, []);

    const { fromCity, toCity } = useSelector((state) => state.cities);
    const filteredData = useSelector((state) => state.flightFilter);
    const loading = useSelector((state) => state.flightOneWay.loading);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 2000);
        return () => clearTimeout(timer);
    }, []);
    const roundCityLoading = useSelector((state) => state.flightRoundCity.filterLoading);
    const flightOneWayloading = useSelector((state) => state.flightOneWay.loading);
    const filterLoading = useSelector((state) => state.flightOneWay.filterLoading);
    const comeFromReview = sessionStorage.getItem("comeFromReview") === "true";

    const isLoaderVisible =
        comeFromReview
            ? false
            : (loading || roundCityLoading || flightOneWayloading || isLoading || filterLoading);

    const location = useLocation();

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
    }, [location.pathname]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const [arrivalDataReturn, setArrivalDataReturn] = useState(null);
    const [departureData, setDepartureData] = useState(null);
    const [selectedValueReturn, setSelectedValueReturn] = useState(0);
    const [selectedValue, setSelectedValue] = useState(0);
    const [shouldLoadOnward, setShouldLoadOnward] = useState(false);
    const [shouldLoadReturn, setShouldLoadReturn] = useState(false);

    useEffect(() => {
        const handleClickAnywhere = () => {
            sessionStorage.removeItem("comeFromReview");
        };

        document.addEventListener("click", handleClickAnywhere);

        return () => {
            document.removeEventListener("click", handleClickAnywhere);
        };
    }, []);


    return (
        <>
            <Seo
                title={filteredData?.filteredData?.popularDestination?.data?.meta_title}
                description={filteredData?.filteredData?.popularDestination?.data?.meta_description}
                link={window.location.href}
                keywords={filteredData?.filteredData?.popularDestination?.data?.meta_keywords}
                largeTwitterCard={true}
                addPostfixTitle={false}
                noIndex={true}
            />

            {/* modify  search engine  */}
            <SearchFlightsUpdate
                setArrivalDataReturn={setArrivalDataReturn}
                setDepartureData={setDepartureData}
                setSelectedValueReturn={setSelectedValueReturn}
                setSelectedValue={setSelectedValue}
                setShouldLoadOnward={setShouldLoadOnward}
                setShouldLoadReturn={setShouldLoadReturn}
            />


            <>
                <section className='result_cntr pt-70 pb-md-70 pt-3'>
                    <div className="container">
                        {isLoaderVisible ? <FlightLoader /> :
                            <Row gutter="20">
                                <Col xl={6} lg={8} md={24} xs={24}>
                                    {/* oneWay fliter component */}
                                    {returnFlightFilter === "oneWay" &&
                                        <div className='d-none d-md-block'>
                                            <ResultFilter />
                                        </div>
                                    }

                                    {/* RoundTripp fliter component */}
                                    {returnFlightFilter === "roundTrip" &&
                                        <div className='d-none d-md-block'>
                                            <RoundTripFilter
                                                arrivalDataReturn={arrivalDataReturn}
                                                setArrivalDataReturn={setArrivalDataReturn}
                                                setDepartureData={setDepartureData}
                                                departureData={departureData}
                                                selectedValueReturn={selectedValueReturn}
                                                setSelectedValueReturn={setSelectedValueReturn}
                                                setSelectedValue={setSelectedValue}
                                                shouldLoadOnward={shouldLoadOnward}
                                                setShouldLoadOnward={setShouldLoadOnward}
                                                shouldLoadReturn={shouldLoadReturn}
                                                setShouldLoadReturn={setShouldLoadReturn}
                                            />
                                        </div>
                                    }

                                    {/* Scroll to top  button in desktop/laptop */}
                                    <div className='scroll_top flight_scroll'> <button onClick={scrollToTop} aria-label="Scroll to top">Scroll to Top <FaChevronUp /></button> </div>
                                </Col>

                                <Col xl={18} lg={16} md={24} xs={24}>
                                    <div className='mb-2 d-md-block d-none'>
                                        {returnFlightFilter === "oneWay" && (
                                            <h1 className='d-flex align-items-center'>{capitalizeWords(fromCity)} to {capitalizeWords(toCity)} Flights, Fares {filteredData?.priceRange?.[0] !== 0 && !loading ?
                                                (<> {''}  @ ₹{filteredData?.priceRange?.[0]} </>) :
                                                (<div className="spinner mx-2" style={{ border: '4px solid black', borderTopColor: 'transparent', width: '24px', height: '24px' }}></div>)}{" "} + 100% Cashback
                                            </h1>
                                        )}
                                        {returnFlightFilter === "roundTrip" && <h1> {capitalizeWords(fromCity)} to {capitalizeWords(toCity)} Flights, and back + 100% Cashback </h1>}
                                    </div>

                                    <RewardPointsToast />

                                    {returnFlightFilter === "oneWay" && <DateChangePreviewNext />}

                                    {/* all flights result component  */}
                                    <ResultFlightsTypeVender
                                        arrivalDataReturn={arrivalDataReturn}
                                        setArrivalDataReturn={setArrivalDataReturn}
                                        setDepartureData={setDepartureData}
                                        departureData={departureData}
                                        selectedValueReturn={selectedValueReturn}
                                        setSelectedValueReturn={setSelectedValueReturn}
                                        selectedValue={selectedValue}
                                        setSelectedValue={setSelectedValue}
                                        shouldLoadOnward={shouldLoadOnward}
                                        setShouldLoadOnward={setShouldLoadOnward}
                                        shouldLoadReturn={shouldLoadReturn}
                                        setShouldLoadReturn={setShouldLoadReturn}
                                    />

                                </Col>
                            </Row>
                        }

                        {/* flight result content accoding search and faq content */}
                        <FlightResultContent />

                    </div>
                </section>


                {/* Scroll to top  button in mobile view */}
                <div className='scroll_top-2'><button onClick={scrollToTop} aria-label="scroll to top"><FaArrowUp /></button></div>
            </>

        </>
    )
}

export default Result
